module.exports = __webpack_public_path__ + "img/stopwatch.fb979348.svg";